"use strict";

(function () {
  'use strict';

  function TripsListCtrl($filter, $stateParams, TripService, ConnectionsService, $timeout) {
    var vm = this;
    this.loading = true;
    this.trips = [];

    this.relativeDate = function (dateStr) {
      return $filter('relativeDate')(dateStr);
    };

    this.$onInit = function () {
      ConnectionsService.getList(2).then(function (data) {
        if (Array.isArray(data) && data.length) {
          vm.pendingApprovals = data.length;
        }
      });
      TripService.getList().then(function (response) {
        vm.trips = angular.copy(response);
        $timeout(function () {
          vm.loading = false;
        }, 1000);
      }, function (error) {
        $timeout(function () {
          vm.loading = false;
        }, 1000);
      });
    };
  }

  TripsListCtrl.$inject = ['$filter', '$stateParams', 'TripService', 'ConnectionsService', '$timeout'];
  angular.module('view.trips').component('tripsList', {
    bindings: {},
    controller: TripsListCtrl,
    templateUrl: 'views/trips/trips-list/trips-list.html'
  });
})();